import { Spin } from 'antd';
import React, { useState } from 'react';
import { connect } from 'dva';
import envConfig from '@hulu/env-config';

import {
  creativesColumnsV2,
  creativeTrackerExportFields,
  creativeTrackerExportFieldsV2,
} from '../../Templates/columns';
import { CreativesTableWrapperV2 } from './CreativesTableWrapperV2';
import { CREATIVETRACKER_V2_TABLE, PERMISSION_PLACEHOLDER } from '../../../testUtils';
import { ResizableTable } from '../../Templates/ResizableTable';
import {
  REVIEW_STATUS_ACCEPTED,
  REVIEW_STATUS_DECLINED,
  REVIEW_STATUS_PARTIAL,
  REVIEW_STATUS_PENDING,
  TABLE_COLUMNS_MAP_V2,
} from '../constants';
import DetailPanel from './DetailPanel';
import { StyledTag } from './styles';
import PreviewModal from './PreviewModal';
import { VIEW } from '../../../constants';
import { TABLE_COLUMNS_MAP } from '../../CreativeTracker/constants';

const TABLE_SCROLL_Y = { y: '60vh' };

const CreativesTableV2 = ({
  pageInitLoading = false,
  pageUpdateLoading = false,
  permissions = PERMISSION_PLACEHOLDER,
  creatives = [],
  creativeWidths = [],
  dispatch,
}) => {
  const [detailPanelData, setDetailPanelData] = useState(null);
  const [detailPanelOpen, setDetailPanelOpen] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');

  const handleMediaPreviewClick = (url) => {
    setVideoUrl(url);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setVideoUrl('');
  };

  const handleRowClick = (record) => {
    setDetailPanelData(record);
    setDetailPanelOpen(true);
  };

  const handleCloseDrawer = () => {
    setDetailPanelOpen(false);
    setDetailPanelData(null);
  };
  const statusItemRenderer = (value) => {
    let reviewStatusTag;

    switch (value) {
      case REVIEW_STATUS_ACCEPTED:
        reviewStatusTag = <StyledTag>ACCEPTED</StyledTag>;
        break;
      case REVIEW_STATUS_PENDING:
        reviewStatusTag = <StyledTag color="purple">PENDING</StyledTag>;
        break;
      case REVIEW_STATUS_PARTIAL:
        reviewStatusTag = <StyledTag color="purple">PARTIAL</StyledTag>;
        break;
      case REVIEW_STATUS_DECLINED:
        reviewStatusTag = <StyledTag color="red">DECLINED</StyledTag>;
        break;
      default:
        reviewStatusTag = <StyledTag>{value}</StyledTag>;
    }
    return reviewStatusTag;
  };

  const columns = creativesColumnsV2(
    creatives,
    creativeWidths,
    statusItemRenderer,
    permissions,
    envConfig.REACT_APP_MISSION_CONTROL_BASE_URL,
    handleMediaPreviewClick
  ).filter(
    (item) =>
      permissions &&
      typeof permissions.can === 'function' &&
      TABLE_COLUMNS_MAP_V2[item.key] &&
      permissions.can(VIEW, TABLE_COLUMNS_MAP_V2[item.key])
  );

  const handleWidthChange = (widths) =>
    dispatch({
      type: 'creativeTrackerV2/updateCreativeWidths',
      payload: widths,
    });

  const filteredExportFields = Object.fromEntries(
    Object.entries(creativeTrackerExportFieldsV2).filter(([key]) => permissions.can(VIEW, TABLE_COLUMNS_MAP_V2[key]))
  );

  return (
    <CreativesTableWrapperV2 data-testid={CREATIVETRACKER_V2_TABLE}>
      <Spin spinning={pageInitLoading || pageUpdateLoading}>
        <ResizableTable
          inputColumns={columns}
          dataSource={creatives}
          scroll={TABLE_SCROLL_Y}
          searchableProps={null}
          pagination={true}
          widthHandler={handleWidthChange}
          refresh={null}
          onRow={(record) => ({
            onClick: () => handleRowClick(record),
            style: { cursor: 'pointer' },
          })}
          exportableProps={{
            fields: filteredExportFields,
            fileName: `CreativeTrackerSnapshot-${new Date().toString()}`,
          }}
        />
      </Spin>
      <DetailPanel
        isOpen={detailPanelOpen}
        onClose={handleCloseDrawer}
        data={detailPanelData}
        statusItemRenderer={statusItemRenderer}
        handleMediaPreviewClick={handleMediaPreviewClick}
      />
      <PreviewModal isVisible={isModalVisible} videoUrl={videoUrl} onClose={handleModalClose} />
    </CreativesTableWrapperV2>
  );
};

function mapStateToProps({ app, creativeTrackerV2, loading }) {
  return {
    pageInitLoading: loading.effects['creativeTrackerV2/pageInit'],
    pageUpdateLoading: loading.effects['creativeTrackerV2/pageUpdate'],
    pathParams: app.pathParams,
    permissions: app.currentUser.permissions,
    creatives: creativeTrackerV2.creatives || [],
    creativeWidths: creativeTrackerV2.creativeWidths || [],
  };
}

export default connect(mapStateToProps)(CreativesTableV2);
